import { render } from "./ISTdashboardView.vue?vue&type=template&id=19dce0d8"
import script from "./ISTdashboardView.vue?vue&type=script&lang=js"
export * from "./ISTdashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__